export default __webpack_public_path__ + "static/media/Clínica-Einstein.cce859ae.jpg";